<template>
  <div class="autocomplete">
    <input 
      type="text" 
      :class="{'disabled-autocomplete': disableInput}"
      :disabled="disableInput"
      class="input-autocomplete form-control" 
      :placeholder="placeHolder"
      v-model="query.value" 
      v-on:keyup="onInput( $event )"
      v-on:click="onInput( $event )"
      @blur="handleVisible(false)"
      >
      <div class="loading-box">
        <div class="loader-autocomplete" v-show="loadingIco"></div>
      </div>
      <ul class="li-options" ref="optionsList" v-show="visible" >
        <li 
          v-for="(item , index) in query.results"
          :key="index"
          @mousedown="itemClicked(item)"
        >
        <h4>
        {{item['sub-district']}} >> {{item.district}} >> {{item.province}} >> {{item.postcode}}
        </h4>
        </li>
    </ul>
  </div>
</template>
<script>
import Addresslist from "../AddressTH/addressTH.js";
export default {

    props: {
      disableInput: Boolean,
      adsTypes: String,
      queryInput:[String, Number],
      placeHolder: String
    },
    data (){
        return {
            query:{
                value: this.queryInput,
                results: []
            },
            visible: false,
            loadingIco: false
        }
    },
    watch: { 
      queryInput(newVal, oldVal) {
        return this.query.value = newVal
      }
    },
    methods:{
      onInput( event ){
        this.$emit('input' , event)
        this.filterAddress()
      },
      filterAddress(){
        if (this.query.value.length < (2 || "")) {
          this.visible = false
          return this.query.results = []
        }else{
          this.visible = true
          this.query.results = Addresslist.filter( value => {
            return String(value[ this.adsTypes ]).includes( this.query.value )
          })
        }
      },
      itemClicked( data ){
        this.visible = false
        this.$emit( 'select:item' , data )
      },
      handleVisible( bool = false ){
        this.visible = bool
        this.loadingIco = bool
      },
    },
}
</script>
<style scoped >
.autocomplete{
  width: 100%;
  position: relative;

}
.relate {

  position: relative;
}

.input-autocomplete {
  width: 100%;
  border-radius: 5px;
}
.li-options {
  font-weight: bold;
    position: absolute;
    background: #f1f1f1;
    width: 200%;
    max-width: 500px;
    z-index: 1;
    list-style-type: none;
    box-shadow: 0 0 1px #00000087;
    top: 55px;
    padding-left: 0;
    overflow-y: overlay;
    max-height: 200px;
    cursor: pointer;

}
.li-options li {
  padding-left: 5px;
    border-bottom: 1px solid #c5c5c5;
}
.li-options li:hover {
  background: white;
}
</style>